import { render, staticRenderFns } from "./PageUser.vue?vue&type=template&id=a8503c76&scoped=true&"
import script from "./PageUser.vue?vue&type=script&lang=js&"
export * from "./PageUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8503c76",
  null
  
)

export default component.exports